
import { Component } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { MenuService } from "@utils/menu-active";
import { ResponsivesidebarService } from "@utils/responsivesidebar";

/**
 * MainHeader component.
 * Provides the main header for the application,
 * including logic to toggle the responsive sidebar.
 */
@Component({
  selector: "app-main-header",
  imports: [RouterModule],
  standalone: true,
  templateUrl: "./main-header.html",
  styleUrls: ["./main-header.scss"],
})
export class MainHeader {
  // constructor(private router: Router, private renderer: Renderer2) {

  // }
  constructor(private responsivesidebarService: ResponsivesidebarService, private router: Router, private menuService: MenuService) { }
  /**
   * Toggles the sidebar open/close state.
   */
  toggleSidebar() {
    this.responsivesidebarService.toggle();
  }
  isDropdownOpen: boolean = false

  /**
   * Toggles the sidebar open/close state.
   */
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Select "basic-setting" in the application menu.
   *
   * Triggers MenuService to set the current menu to 'basic-setting'.
   * Used by the header action to switch the active view without route navigation.
   */
  basicSetting() {
    // this.router.navigate(['/basic-setting']);
    this.menuService.setMenu('basic-setting');
  }

  /**
   * Logs out the current user by clearing user-related data from localStorage and sessionStorage,
   * then navigates to the home or login page.
   * Logs the result of the navigation for debugging purposes.
   */
  logout(): void {
    // Clear user-related data
    localStorage.removeItem('user_id');  // Adjust if you have specific keys
    localStorage.clear();           // Clear session storage if used

    // Navigate to the login page or home page
    this.router.navigate(['/']).then(() => {
      console.log('Logout successful');  // Optional: Log or handle post-logout actions
    }).catch(error => {
      console.error('Logout failed', error);  // Handle navigation errors
    });
  }
}
